import singleSelectRowInternal from './singleSelectRowInternal';
/**
 * Select the first row
 * @param mailListItemSelectionSource selection mode for the maillist item
 */
export default function selectFirstRow(tableView, mailListItemSelectionSource) {
    var tableRowKeys = tableView.rowKeys;
    singleSelectRowInternal(tableView, tableRowKeys[0], true /* isUserNavigation */, mailListItemSelectionSource);
}
//# sourceMappingURL=selectFirstRow.js.map